import { Component, Input } from '@angular/core'

@Component({
    selector: 'mg-ui-animated-check-dot',
    templateUrl: './ui-animated-check-dot.component.html',
    styleUrls: ['./ui-animated-check-dot.component.scss'],
})
export class UiAnimatedCheckDotComponent {
    @Input()
    isChecked = false
}
